import styled from 'styled-components';

export const StaticPageIframe = styled('iframe') `
	width: 100%;
	height: 100%;
	border: none;
	vertical-align: top;
`;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/StaticPage/styles.ts